module.exports = __webpack_public_path__ + "img/chart.8dcfba35.png";